<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      :default-status="1"
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as AGREEMENT_DOCUMENT_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'AgreementDocumentCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: AGREEMENT_DOCUMENT_TYPES.GENERIC.agreement.agreementdocument.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...AGREEMENT_DOCUMENT_TYPES.GENERIC.agreement.agreementdocument.LIST.ACTIONS
    })
  }
}
</script>
